import { writable, get } from "svelte/store";
import { axiosCall, createHeader } from "./common";
import { setPlansData } from "../store/store-plan";
import { loadStripe } from "@stripe/stripe-js/pure";
export const stripeStore = writable(null);
async function init() {
    if (get(stripeStore))
        return;
    // Stripe.js will not be loaded until `loadStripe` is called
    const instance = await loadStripe('pk_test_51M3Mh2Lf1oQunPSDVoTkhxX6N1HjtRgORZbMP0GJcEIge2GaZZvZjNnY4KWy4kOiq5WL1AwQMoQNiUjNNAuGIm4I00ABck0deh');
    stripeStore.set(instance);
}
init();
export async function getPlanInfo(config) {
    const requestConfig = { url: '/plan/info', method: 'get' };
    const data = await axiosCall(requestConfig, config);
    if (data)
        setPlansData(data);
}
export async function createSubscription(items, config) {
    const requestConfig = { url: '/plan/createSubscription', method: 'post', data: { items }, headers: createHeader({}) };
    const subscription = await axiosCall(requestConfig, config);
    console.log("create subscription ", subscription);
    return subscription;
}
export async function cancelSubscription(subscriptionId, config) {
    const requestConfig = { url: '/plan/cancelSubscription', method: 'post', data: { subscriptionId }, headers: createHeader({}) };
    const subscription = await axiosCall(requestConfig, config);
    console.log("cancel subscription ", subscription);
    return subscription;
}
export async function getCurrentSubscription(config) {
    const requestConfig = { url: '/plan/current', method: 'get', headers: createHeader({}) };
    const res = await axiosCall(requestConfig, config);
    return res;
}
